import { attributesToProps } from 'html-react-parser';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import type { ParserProps } from '@/app_lib/htmlParser/types';

const Iframe = dynamic(() => import('@/app_components/common/iframe').then((mod) => mod.Iframe));

export const IframeParser = ({ domNode }: ParserProps) => {
  const { attribs } = domNode;
  // TODO! in the future we should have is video kinda flags to check proper aspect ratios
  const props = attributesToProps(attribs);
  return (
    <Suspense fallback={<div className='w-full aspect-video bg-gray-200 animate-pulse' />}>
      <Iframe {...props} />
    </Suspense>
  );
};
